import { render } from "./ControlSheetsSkeleton.vue?vue&type=template&id=72aa5408&ts=true"
import script from "./ControlSheetsSkeleton.vue?vue&type=script&lang=ts"
export * from "./ControlSheetsSkeleton.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ControlSheetsSkeleton.vue?vue&type=style&index=0&id=72aa5408&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__